var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"chart",staticClass:"falcon-chart",class:_vm.locked? 'locked': '',style:({'height': _vm.print? '200px':'400px'})}),_c('div',{staticClass:"chart-label"},[_vm._v(" Valuations amount ranges in Million of Dollars ")])])}
var staticRenderFns = []

export { render, staticRenderFns }